import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=195d565a&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=195d565a&prod&lang=scss&scoped=true"
import style1 from "./summary.vue?vue&type=style&index=1&id=195d565a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d565a",
  null
  
)

export default component.exports